import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { getVideoEmbedInfo } from '@/lib/utils/video';

interface VideoIntroPlayerProps {
  url: string;
  isOpen: boolean;
  onClose: () => void;
}

export function VideoIntroPlayer({ url, isOpen, onClose }: VideoIntroPlayerProps) {
  const videoInfo = getVideoEmbedInfo(url);

  if (!videoInfo.type || !videoInfo.embedUrl) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="max-w-[calc(100%-2rem)] sm:max-w-6xl rounded-[40px] p-8">
          <DialogHeader>
            <DialogTitle className="text-2xl">Video Introduction</DialogTitle>
          </DialogHeader>
          <div className="flex items-center justify-center p-8">
            <p className="text-slate-500">Invalid video URL. Please provide a valid YouTube, Vimeo, or Loom URL.</p>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[calc(100%-2rem)] sm:max-w-6xl rounded-[40px] p-0 overflow-hidden">
        <DialogHeader className="px-8 pt-8 pb-4">
          <DialogTitle className="text-2xl font-semibold text-slate-900">Video Introduction</DialogTitle>
        </DialogHeader>
        <div className="relative aspect-video bg-black rounded-[32px] mx-8 mb-8 overflow-hidden">
          <iframe
            src={videoInfo.embedUrl}
            className="w-full h-full rounded-[32px]"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Video Introduction"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

